<script lang="ts">
	import compass from '$lib/assets/images/icons/compass-large.svg';
	import __ from '$lib/stores/TranslationStore';
	import Cta from '../Global/Cta.svelte';
</script>

<div class="bg-secondary-bright">
	<div class="container mx-auto max-w-5xl py-16 text-center text-white">
		<img src={compass} class="mx-auto" alt="simulação" />
		<h3 class="mt-12 text-4xl font-semibold lg:mt-16 lg:text-6xl">
			{$__('Poupe até 60% no seu seguro de vida')}
		</h3>
		<p class="mt-6 text-lg font-light leading-8 lg:mt-12 lg:text-2xl">
			{$__(
				'Encontramos o melhor Seguro de Vida para o seu Crédito Habitação, com as coberturas certas para si.'
			)}
		</p>
		<div class="text-center">
			<Cta
				type="anchor"
				class="mt-10 inline-block bg-primary-light px-10 py-4 font-semibold leading-nav-button text-dark md:border-0 lg:mt-20 lg:px-32 2xl:text-nav-button"
				props={{ href: '/simulador/seguro-vida-habitacao' }}
			>
				{$__('Simular seguro')}
			</Cta>
		</div>
	</div>
</div>
